import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const BotsHero = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <div className="bots-hero-wrap">
      <h1 className="bots-hero-title">
        BOT <span className="bots-hero-title-accent">NEXUS</span>
      </h1>
      <p className="bots-hero-subtitle">
        {isEn
          ? 'Connect to the target server below to prepare for bot deployment. Basic server information will be verified upon connection.'
          : 'Подключитесь к целевому серверу ниже, чтобы подготовиться к развертыванию бота. Основная информация о сервере будет проверена при подключении.'}
      </p>
    </div>
  );
};

export default BotsHero;
